import axios from "axios";
import NewsLetterSignupRequest from "api/model/NewsLetterSignupRequest";

export const signupForNewsLetter = (request: NewsLetterSignupRequest) => axios.post('/api/users/news-letter', request);